module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/babel-runtime/core-js/object/create.js
// module id = ../../node_modules/babel-runtime/core-js/object/create.js
// module chunks = widget-7.1.6